import PropTypes from 'prop-types';
import React from 'react';
import { StyleSheet, View, Text, Platform, Pressable, Image } from 'react-native';
import { COLOR, FONT, FONT_SIZE, THEME } from '../../../constants/styles';

export default class MessageGift extends React.Component {
  constructor(props) {
    super(props);
  }

  shouldComponentUpdate(nextProps) {
    return this.props.currentMessage.text !== nextProps.currentMessage.text;
  }

  handlePress = () => {
    this.props.playGiftMessage?.(this.props.currentMessage, true);
  };

  render() {
    const { position, currentMessage } = this.props;
    let textString = currentMessage.text;

    if (currentMessage.playAnimationOnRender) {
      this.props.playGiftMessage?.(this.props.currentMessage);
    }

    return (
      <Pressable style={styles[position].container} onPress={this.handlePress}>
        <Text style={styles[position].text}>{textString.substring(2, textString.length - 2)}</Text>
        <Image
          style={styles[position].refreshIcon}
          source={require('../../../../resources/icon-resend.png')}
        />
      </Pressable>
    );
  }
}

const textStyle = {
  fontSize: 16,
  lineHeight: 20,
  marginTop: 5,
  marginBottom: 5,
  marginLeft: 0,
  marginRight: 0,
};

const containerStyle = {
  flexDirection: 'row',
  alignItems: 'center',
};

const styles = {
  left: StyleSheet.create({
    container: {
      ...containerStyle,
      padding: 10,
    },
    text: {
      ...FONT.bold,
      ...textStyle,
      color: COLOR.text,
    },
    refreshIcon: {
      tintColor: COLOR.text,
      width: 18,
      height: 18,
      marginLeft: 10,
    },
  }),
  right: StyleSheet.create({
    container: {
      ...containerStyle,
      padding: 10,
    },
    text: {
      ...FONT.bold,
      ...textStyle,
      color: COLOR.contrast,
    },
    refreshIcon: {
      tintColor: COLOR.contrast,
      width: 18,
      height: 18,
      marginLeft: 10,
    },
  }),
};

MessageGift.defaultProps = {
  position: 'left',
  currentMessage: {
    text: '',
  },
  textProps: {},
};
